import { makeStyles, Theme } from "@material-ui/core";
import React, { FC } from "react";
import { Field } from "react-final-form";
import Autocomplete from "../../../components/Autocomplete";
import { HOUSING_TYPES, INTAKES, PROGRAM_TYPES } from "../../program/constants";
import { SCHOOL_GRADE } from "../constants";

const useStyles = makeStyles((theme: Theme) => ({
  formControl: {
    marginTop: theme.spacing(3),
  },
}));

const AcademicsFilterFormSecondary: FC = () => {
  const classes = useStyles();

  return (
    <>
      <div className={classes.formControl}>
        <Field
          fullWidth
          name="grade"
          label="School Grade"
          placeholder="School Grade"
          options={SCHOOL_GRADE}
          component={Autocomplete}
        />
      </div>
      <div className={classes.formControl}>
        <Field
          fullWidth
          name="programType"
          label="Program Type"
          placeholder="Program Type"
          options={PROGRAM_TYPES}
          component={Autocomplete}
        />
      </div>
      <div className={classes.formControl}>
        <Field
          fullWidth
          name="housingType"
          label="Housing Type"
          placeholder="Housing Type"
          options={HOUSING_TYPES}
          component={Autocomplete}
        />
      </div>
      <div className={classes.formControl}>
        <Field
          fullWidth
          name="intake"
          label="Intake"
          placeholder="Intake"
          options={INTAKES}
          component={Autocomplete}
        />
      </div>
    </>
  );
};

export default React.memo(AcademicsFilterFormSecondary);
